var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154.86 148.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 10px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: gray;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n        stroke-width: 13px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.09,118.87h99.66c7.25,0,13.12-5.87,13.12-13.12V18.12c0-7.25-5.87-13.12-13.12-13.12H18.12c-7.25,0-13.12,5.87-13.12,13.12V105.75s0,33.47,0,33.47l32.09-20.35Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 121.34,
    y1: 41.06,
    x2: 30.43,
    y2: 41.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 91.09,
    y1: 77,
    x2: 30.43,
    y2: 77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAsset);
export default __webpack_public_path__ + "static/media/messageAsset.a4444f42532c66ff80709d028c9f36e9.svg";
export { ForwardRef as ReactComponent };